import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { withTranslation } from 'react-i18next';

import Sector from '../../components/sector/Sector';
import Product from '../../components/product/Product';
import Page from '../../components/page/Page';
import { ga4TrackSearch } from '../../core/utils';

class SearchResults extends React.Component {

    render() {
        const {props: {basket: {items, totalPrice}, search: {results}}} = this;

        if (!results) {            
            return null;
        }
        
        const {query, sectors, sectorsCount, products, productsCount, pages, pagesCount} = results;
        
        if (sectorsCount === 0 && productsCount === 0 && pagesCount === 0) {
            ga4TrackSearch( query, 'not-found', results.searchSource );
        } else {
            ga4TrackSearch( query, 'found', results.searchSource );
        }
        
        return (
                <React.Fragment>
                
                {(sectorsCount === 0 && productsCount === 0 && pagesCount === 0 ) && 
                    <div id="autocomplete" className="bbb-overlay" >
                        <h4>{ this.props.t( 'search.results.headline' ) } <b>{query}</b></h4>
                        <ul className="product-list">
                            <li>{ this.props.t( 'search.results.noResults' ) }</li>
                        </ul>
                        <div className="footer">
                            <a href={this.props.settings.links.contactLink} >
                            { this.props.t( 'search.results.contactLink' ) } <i className="glyphicon glyphicon-menu-right"></i>
                            </a>
                        </div>
                    </div>
                }
                {(sectorsCount > 0 || productsCount > 0 || pagesCount > 0) && 
                    <div id="autocomplete" className="bbb-overlay" >
                     
                        {sectors && sectors.length > 0 && <React.Fragment>
                            <h4>{ this.props.t( 'search.results.categories' ) }</h4>
                            <ul className="sector-list">
                                {sectors.map(sector => {
                                      return <Sector key={sector.sectorUrl} sector={sector} />;
                                })}
                            </ul>
                            </React.Fragment>
                        }

                        {products && products.length > 0 && <React.Fragment>
                            <h4>{ this.props.t( 'search.results.products' ) }</h4>
                            <ul className="product-list">
                            {products.map( product => {
                                
                                const basketItemArr = items.filter( i =>  i.catalogNumber === product.catalogNumber );
                                const qty = basketItemArr.length > 0 ? basketItemArr[0].qty : 0;
                                
                                return <Product key={product.id} qty={qty} product={product} />;
                            })}
                            </ul>
                            </React.Fragment>
                        }
                        
                        {pages && pages.length > 0 && <React.Fragment>
                            <h4>{ this.props.t( 'search.results.pages' ) }</h4>
                            <ul className="page-list">
                                {pages.map(page => {
                                      return <Page key={page.url} page={page} />;
                                })}
                            </ul>
                            </React.Fragment>
                        }
                        
                        <div className="footer">
                            <a href={`${this.props.settings.links.searchLink}?q=${query}`} >
                                {productsCount} { this.props.t( 'search.results.totalProducts' ) }<i className="glyphicon glyphicon-menu-right"></i>
                            </a>
                        </div>
                    </div>
                }
                </React.Fragment>
          );
    }

}

const mapStateToProps = (state) => ({
    search: state.search,
    basket: state.basket,
    settings: state.settingsReducer
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()( SearchResults ));
